import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { fmtDate } from "@/lib/posts";

export const PostCard = ({ post, big = false }) => {
  const { lang } = useLang();
  return (
    <Link to={`/blog/${post.slug}`} data-testid={`post-card-${post.slug}`}
      className={`group bento-cell h-full flex flex-col rounded-[28px] border border-[var(--line)] bg-[var(--card)] overflow-hidden ${big ? "lg:flex-row" : ""}`}>
      <div className={`relative overflow-hidden ${big ? "aspect-[16/10] lg:aspect-auto lg:w-3/5" : "aspect-[16/10]"}`}>
        <img src={post.cover} alt={post.title[lang]} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
        <span className="absolute top-4 left-4 font-mono text-[11px] uppercase tracking-[0.2em] bg-[#0c0a09]/80 backdrop-blur px-3 py-1.5 rounded-full text-[var(--gold)]">{post.tag[lang]}</span>
      </div>
      <div className={`flex-1 flex flex-col p-6 md:p-8 ${big ? "lg:justify-center lg:p-12" : ""}`}>
        <p className="font-mono text-xs text-stone-400">{fmtDate(post.date, lang)} · {post.readMin} min</p>
        <h3 className={`mt-3 font-display leading-tight group-hover:text-[var(--gold)] transition-colors ${big ? "text-3xl md:text-5xl" : "text-2xl md:text-3xl"}`}>{post.title[lang]}</h3>
        <p className="mt-4 text-stone-300 text-sm md:text-base leading-relaxed flex-1">{post.excerpt[lang]}</p>
        <span className="mt-6 inline-flex items-center gap-2 text-sm text-[var(--gold)]">
          {lang === "it" ? "Leggi l'articolo" : "Read the article"}
          <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
};
